import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { animalsApi } from "./api/animalsApi";
import { bookingsApi } from "./api/bookingsApi";
import { customersApi } from "./api/customersApi";
import { eventsApi } from "./api/eventsApi";
import { invoicesApi } from "./api/invoicesApi";
import { calendarApi } from "./api/calendarApi";
import { logsApi } from "./api/logsApi";
import { timelineApi } from "./api/timelineApi";
import { configurationsApi } from "./api/configurationsApi";
import { serviceBookingsApi } from "./api/serviceBookingsApi";
import { serviceSeriesApi } from "./api/serviceSeriesApi";
import { serviceSeriesBookingsApi } from "./api/serviceSeriesBookingsApi";
import formMemoryReducer from "./slices/formMemorySlice";
import timelineSettingsReducer from "./slices/timelineSettingsSlice";
import filtersReducer from "./slices/filtersSlice";
import calendarUIReducer from "./slices/calendarUiSlice";
import calendarEventsReducer from "./slices/calendarEventsSlice";
import { capacitiesReducer } from "./slices/capacitiesSlice";
import { spacesReducer } from "./slices/spacesSlice";

export const store = configureStore({
  reducer: {
    [customersApi.reducerPath]: customersApi.reducer,
    [animalsApi.reducerPath]: animalsApi.reducer,
    [bookingsApi.reducerPath]: bookingsApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [invoicesApi.reducerPath]: invoicesApi.reducer,
    [calendarApi.reducerPath]: calendarApi.reducer,
    [logsApi.reducerPath]: logsApi.reducer,
    [configurationsApi.reducerPath]: configurationsApi.reducer,
    [serviceBookingsApi.reducerPath]: serviceBookingsApi.reducer,
    [serviceSeriesApi.reducerPath]: serviceSeriesApi.reducer,
    [serviceSeriesBookingsApi.reducerPath]: serviceSeriesBookingsApi.reducer,
    [timelineApi.reducerPath]: timelineApi.reducer,
    formMemory: formMemoryReducer,
    timelineSettings: timelineSettingsReducer,
    filters: filtersReducer,
    calendarUI: calendarUIReducer,
    calendarEvents: calendarEventsReducer,
    capacities: capacitiesReducer,
    spaces: spacesReducer,
  },
  middleware: (getDefault) =>
    getDefault().concat(
      customersApi.middleware,
      animalsApi.middleware,
      bookingsApi.middleware,
      eventsApi.middleware,
      invoicesApi.middleware,
      calendarApi.middleware,
      logsApi.middleware,
      timelineApi.middleware,
      configurationsApi.middleware,
      serviceBookingsApi.middleware,
      serviceSeriesApi.middleware,
      serviceSeriesBookingsApi.middleware
    ),
  devTools: process.env.NODE_ENV !== "production",
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
